import { Action, Reducer } from 'redux';
import { IAppState } from './IAppState';
import { markGuestPdfPrintedReducer } from '../../guest/entitlements/media/passPrinting/markGuestPdfPrintedAction';
import { getUsersReducer } from '../../admin/userManagement/getUsersAction';
import { addUserReducer } from '../../admin/userManagement/addUserAction';
import { deleteUserReducer } from '../../admin/userManagement/deleteUserAction';
import { updateUserReducer } from '../../admin/userManagement/updateUserAction';
import { getConfigReducer } from '../../auth/config/getConfigAction';
import { copyToClipboardReducer } from '../../copyToClipboard/copyToClipboardAction';
import { clearApiErrorReducer } from './api/clearApiErrorAction';
import { assocRfidReducer } from '../../guest/entitlements/media/assocRfid/assocRfidAction';
import { getGuestPhotoReducer } from '../../guest/guestPhoto/getGuestPhotoAction';
import { setGuestPhotoReducer } from '../../guest/guestPhoto/setGuestPhotoAction';
import { guestEntitlementsReducer } from '../../guest/entitlements/guestEntitlementsAction';
import { submitWaiverReducer } from '../../guest/entitlements/waivers/submitWaiverAction';
import { submitRedemptionLocalRefReducer } from '../../guest/entitlements/redemption/submitRedemptionLocalRefAction';
import { importGuestReducer } from '../../guest/importGuest/importGuestAction';
import { snackbarReducer } from '../../snackbar/snackbarAction';
import { dismissModalReducer } from '../modal/dismissModalAction';
import { showModalReducer } from '../modal/showModalAction';
import { reissueMediaReducer } from '../../guest/entitlements/media/passPrinting/reissueMediaAction';
import { saveConfigReducer } from '../../admin/systemAdmin/saveConfigAction';
import { redeemEntitlementReducer } from '../../guest/entitlements/redemption/redeemEntitlementAction';
import { clearRedeemedEntitlementReducer } from '../../guest/entitlements/redemption/clearRedeemedEntitlementAction';
import { getResortRedemptionsReducer } from '../../guest/entitlements/redemption/viewDays/getResortRedemptionsAction';
import { getRedemptionTypesReducer } from '../../guest/entitlements/redemption/viewDays/getRedemptionTypesAction';
import { loadFaqsReducer } from '../../appDocs/faq/loadFaqsAction';
import { clearFaqsReducer } from '../../appDocs/faq/clearFaqsAction';
import { getResortDetailsReducer } from '../../resortDetails/getResortDetailsAction';
import { getEntitlementTypesReducer } from '../../entitlementTypes/getEntitlementTypesAction';
import { getGuestDetailsReducer } from '../../guest/guestDetailsAction';
import { getMediaHistoryReducer } from '../../guest/entitlements/media/mediaHistory/getMediaHistoryAction';
import { getValidLiftAccessLocationsReducer } from '../../guest/entitlements/liftAccess/getValidLiftAccessLocationsAction';
import { getHotlistReasonsReducer } from '../../guest/hotlist/getHotlistReasonsAction';
import { getEntitlementHotlistReducer } from '../../guest/entitlements/guestEntitlementHotlistAction';
import { getEntitlementHotlistTypesReducer } from '../../guest/hotlist/getEntitlementHotlistTypesAction';
import { addToHotlistReducer } from '../../guest/hotlist/addToHotlistAction';
import { removeFromEntitlementHotlistReducer } from '../../guest/hotlist/removeFromEntitlementHotlistAction';
import { guestSearchReducer } from '../../guestSearch/guestSearchAction';
import { getDtwEntitlementsReducer } from '../../guest/entitlements/redemption/directToWindow/getDtwEntitlementsAction';
import { getFnfEntitlementsReducer } from '../../guest/entitlements/redemption/friendsAndFamily/getFnFEntitlementsAction';
import { householdReducer } from '../../guestSearch/household/householdAction';
import { addGuestCommentReducer } from '../../guest/guestComments/addGuestCommentAction';
import { getGuestCommentsReducer } from '../../guest/guestComments/getGuestCommentsAction';
import { loadReleaseNotesReducer } from '../../appDocs/releaseNotes/loadReleaseNotesAction';
import { loadTrainingDocumentsReducer } from '../../helpAndTraining/loadTrainingDocumentsAction';
import { clearTrainingDocumentsReducer } from '../../helpAndTraining/clearTrainingDocumentsAction';
import { uploadTrainingDocumentReducer } from '../../helpAndTraining/uploadTrainingDocumentAction';
import { replaceTrainingDocumentReducer } from '../../helpAndTraining/replaceTrainingDocumentAction';
import { deleteTrainingDocumentReducer } from '../../helpAndTraining/deleteTrainingDocumentAction';
import { clearReleaseNotesReducer } from '../../appDocs/releaseNotes/clearReleaseNotesAction';
import { getHasCommentsReducer } from '../../guest/guestComments/getHasCommentsAction';
import { inactivityReducer } from '../../auth/login/inactivityReducer';
import { clearResortRedemptionsReducer } from '../../guest/entitlements/redemption/viewDays/clearResortHistoryAction';
import { getRedemptionHistoryReducer } from '../../guest/entitlements/redemption/viewDays/getRedemptionHistoryAction';
import { getApplianceVersionReducer } from '../getApplianceVersionAction';
import { waiverLookupReducer } from '../../guest/entitlements/waivers/waiverLookupAction';
import { disableMediaReducer } from '../../guest/entitlements/media/mediaHistory/disableMediaAction';
import { getEntitlementSharesReducer } from '../../guest/entitlements/getEntitlementSharesAction';
import { getResortMappingReducer } from '../../resortMappingTool/getResortMappingAction';
import { getResortMappingErrorReducer, resortMappingErrorRequestedReducer } from '../../resortMappingTool/getResortMappingErrorAction'
import { updateResortMappingReducer}  from '../../resortMappingTool/updateResortMappingAction';
import { updateRowReducer } from '../../resortMappingTool/updateRow';
import { revertResortMappingRowsReducer } from '../../resortMappingTool/revertResortMappingRowsAction';
import { sortProductsReducer } from '../../resortMappingTool/sortProductsAction';
import { enableMediaReducer } from '../../guest/entitlements/media/mediaHistory/enableMediaAction';
import { updatePasswordReducer } from '../../admin/userManagement/updatePasswordAction';
import { userStateReducer } from '../../auth/login/userStateAction';
import { authStateReducer } from '../../auth/authAction';
import { getUserReducer } from '../../auth/getUserInfoAction';
import { selectedResortReducer } from '../../auth/login/selectedResortAction';
import { updateLastResortReducer } from '../../auth/updateLastResortAction';
import { checkUsernameReducer } from '../../admin/userManagement/checkUsernameAction';
import { blockUserReducer } from '../../admin/userManagement/blockUserAction';
import { unblockUserReducer } from '../../admin/userManagement/unblockUserAction';
import { updateReleaseNotesReducer } from '../../appDocs/releaseNotes/updateReleaseNotesAction';
import { updateFaqsReducer } from '../../appDocs/faq/updateFaqsAction';
import { updateResortMappingRTPReducer } from '../../resortMappingTool/updateMappingErrorsRTPAction';
import { updateResortMappingSWReducer } from '../../resortMappingTool/updateMappingErrorsSWAction';
import { defaultConfigReducer } from '../../auth/config/defaultConfigAction';
import { getResortMappingHasErrorReducer } from '../../resortMappingTool/getResortMappingHasErrorAction';
import localeReducer from '../../language/resources/setLocaleAction';
import dateFormatReducer from '../../language/setDefaultDate';
import { getProductHydrationErrorsReducer } from '../../resortMappingTool/getProductHydrationErrorsAction';
import { setProductMappingUnsavedEditsReducer } from '../../resortMappingTool/setProductMappingUnsavedEditsAction';
import { retryProductHydrationErrorsReducer } from '../../resortMappingTool/retryProductHydrationErrorsAction';
import { clearResortMappingReducer } from '../../resortMappingTool/clearResortMappingAction';
import { updateUserPreferenceReducer } from '../../admin/userManagement/updateUserPreferenceAction';
import { scriptVersionReducer } from '../../admin/systemAdmin/getScriptVersionAction';
import { userSearchHistoryReducer } from '../../guestSearch/getUserSearchHistoryAction';
import { clearSearchHistoryReducer } from '../../guestSearch/clearUserSearchHistoryAction';
import { getGuestPaymentRegistrationsReducer } from '../../guest/guestPayment/getGuestPaymentRegistrationAction';
import { getPaymentMethodReducer } from '../../guest/guestPayment/getPaymentMethodAction';
import { deactivateGuestPaymentRegistrationReducer } from '../../guest/guestPayment/deactivateGuestPaymentRegistrationAction';
import { getPaymentGuestReducer } from '../../guest/guestPayment/getPaymentGuestAction';
import { getFnFBlackoutDateMetadataReducer } from '../../guest/entitlements/redemption/friendsAndFamily/getFnFBlackoutDateMetadataAction';
import { getLiftBlackoutDateMetadataReducer } from '../../guest/entitlements/redemption/directToWindow/getLiftBlackoutDateMetadataAction';
import { getGuestHydrationErrorsReducer } from '../../reports/hydrationErrorReport/getGuestHydrationErrorsAction';
import { replayGuestHydrationErrorsReducer } from '../../reports/hydrationErrorReport/replayGuestHydrationErrorsAction';
import { getGuestHydrationErrorsCountReducer } from '../../reports/hydrationErrorReport/getGuestHydrationErrorsCountAction';
import { getWeeklyVisitorDataReportsReducer } from '../../reports/weeklyVisitorReport/getWeeklyVisitorReportsAction';
import { clearWeeklyVisitorReportsReducer } from '../../reports/weeklyVisitorReport/clearWeeklyVisitorReportsAction';
import { clearGuestHydrationErrorReportReducer } from '../../reports/hydrationErrorReport/clearGuestHydrationErrorReportAction';
import { getSeasonReprintCountReducer } from '../../guest/entitlements/media/passPrinting/getSeasonReprintCountAction';
import { getSellingSeasonsReducer } from '../../productAdministration/getSellingSeasonsAction';
import { getFulfillmentSeasonsReducer } from '../../productAdministration/getFulfillmentSeasonsAction';
import { searchLiftAccessRulesReducer } from '../../productAdministration/searchLiftAccessRulesAction';
import { bulkCorrectionReducer } from '../../guest/entitlements/redemption/bulkCorrectionAction';
import { migrateRedemptionsReducer } from '../../guest/entitlements/redemption/migrateRedmeptionsAction';
import { bulkAddLiftAccessRulesReducer } from '../../productAdministration/bulkAddLiftAccessRulesAction';
import { saveLiftAccessRulesReducer } from '../../productAdministration/saveLiftAccessRulesAction';
import { bulkDeleteLiftAccessRulesReducer } from '../../productAdministration/bulkDeleteLiftAccessRuleSetsAction';
import { getEffectiveDateRangeHistoryReducer } from '../../validationConfigurationTool/getEffectiveDateRangeHistoryAction';
import { getEditableEffectiveDateRangeRulesReducer } from '../../validationConfigurationTool/getEditableEffectiveDateRangeRulesAction';
import { updateEditableEffectiveDateRangeRulesReducer } from '../../validationConfigurationTool/updateEditableEffectiveDateRangeRulesAction';

/**
 * List of all app state reducers. These are functions that take actions and your previous app state, and calculate out
 * the next app state. Reducers have to be pure functions. Reducers are run in their order in this array (not that order
 * should matter).
 */
const reducers: Array<Reducer<IAppState>> = [
  assocRfidReducer,
  householdReducer,
  getGuestPhotoReducer,
  setGuestPhotoReducer,
  submitWaiverReducer,
  waiverLookupReducer,
  guestSearchReducer,
  userSearchHistoryReducer,
  clearSearchHistoryReducer,
  importGuestReducer,
  getGuestDetailsReducer,
  getMediaHistoryReducer,
  getValidLiftAccessLocationsReducer,
  disableMediaReducer,
  enableMediaReducer,
  getResortDetailsReducer,
  getEntitlementTypesReducer,
  inactivityReducer,
  getApplianceVersionReducer,
  localeReducer,
  dateFormatReducer,
  bulkCorrectionReducer,
  migrateRedemptionsReducer,

  // PowCoin
  getGuestPaymentRegistrationsReducer,
  deactivateGuestPaymentRegistrationReducer,
  getPaymentMethodReducer,
  getPaymentGuestReducer,

  //User State
  userStateReducer,
  getUserReducer,
  selectedResortReducer,

  // Misc
  snackbarReducer,
  copyToClipboardReducer,
  clearApiErrorReducer,
  showModalReducer,
  dismissModalReducer,

  // Entitlements
  guestEntitlementsReducer,
  redeemEntitlementReducer,
  getDtwEntitlementsReducer,
  getFnfEntitlementsReducer,
  submitRedemptionLocalRefReducer,
  clearRedeemedEntitlementReducer,
  getResortRedemptionsReducer,
  clearResortRedemptionsReducer,
  getRedemptionHistoryReducer,
  getRedemptionTypesReducer,
  getEntitlementSharesReducer,
  getFnFBlackoutDateMetadataReducer,
  getLiftBlackoutDateMetadataReducer,

  // Resort Mapping
  getResortMappingReducer,
  getResortMappingErrorReducer,
  getResortMappingHasErrorReducer,
  updateResortMappingReducer,
  updateResortMappingRTPReducer,
  updateResortMappingSWReducer,
  updateRowReducer,
  revertResortMappingRowsReducer,
  setProductMappingUnsavedEditsReducer,
  sortProductsReducer,
  getProductHydrationErrorsReducer,
  retryProductHydrationErrorsReducer,
  clearResortMappingReducer,
  resortMappingErrorRequestedReducer,

  // Validation Configuration
  getEditableEffectiveDateRangeRulesReducer,
  getEffectiveDateRangeHistoryReducer,
  updateEditableEffectiveDateRangeRulesReducer,

  // PDF Printing
  markGuestPdfPrintedReducer,
  reissueMediaReducer,
  getSeasonReprintCountReducer,

  // Comments
  getHasCommentsReducer,
  getGuestCommentsReducer,
  addGuestCommentReducer,

  // Hotlist
  getHotlistReasonsReducer,
  getEntitlementHotlistTypesReducer,
  getEntitlementHotlistReducer,
  addToHotlistReducer,
  removeFromEntitlementHotlistReducer,

  // Auth
  getConfigReducer,
  authStateReducer,

  // User Management
  getUsersReducer,
  addUserReducer,
  deleteUserReducer,
  updateUserReducer,
  updatePasswordReducer,
  updateLastResortReducer,
  updateUserPreferenceReducer,
  checkUsernameReducer,
  blockUserReducer,
  unblockUserReducer,

  // System Administration
  saveConfigReducer,
  defaultConfigReducer,
  scriptVersionReducer,

  // FAQ
  loadFaqsReducer,
  clearFaqsReducer,
  updateFaqsReducer,

  // Release Notes
  loadReleaseNotesReducer,
  clearReleaseNotesReducer,
  updateReleaseNotesReducer,

  // Help and Training
  loadTrainingDocumentsReducer,
  clearTrainingDocumentsReducer,
  uploadTrainingDocumentReducer,
  replaceTrainingDocumentReducer,
  deleteTrainingDocumentReducer,

  // Reports
  getGuestHydrationErrorsCountReducer,
  getGuestHydrationErrorsReducer,
  clearGuestHydrationErrorReportReducer,
  replayGuestHydrationErrorsReducer,
  getWeeklyVisitorDataReportsReducer,
  clearWeeklyVisitorReportsReducer,

  // Product Administration
  getSellingSeasonsReducer,
  getFulfillmentSeasonsReducer,
  searchLiftAccessRulesReducer,
  saveLiftAccessRulesReducer,
  bulkAddLiftAccessRulesReducer,
  bulkDeleteLiftAccessRulesReducer,
];


export const rootReducer: Reducer<IAppState> = (state: IAppState, action: Action) => reducers.reduce(
  (running, next) => next(running, action),
  state,
);
